export default __webpack_public_path__ + "assets/icons/txt-icon.c05b288a.svg";